<template>
  <CustomModal id="extra-content-edit-modal"
               class="basic-modal extra-content-edit-modal"
              :isCustomFooter="true"
              >
    <div class="extra-content-edit-modal__title" slot="modal-header">
      긴지문 설정
      <button
        type="button"
        class="btn btn-danger ml-20"
        @click="remove()"
        :disabled="!hasExtraContent"
      >
        삭제
      </button>
    </div>

    <div class="extra-content-edit-modal__form">
      <div class="form-group">
        <label for="extra-content-title-input"
              class="typography--body-3 typography--color-secondary typography--font-weight-600">
          제목
        </label>
        <input
          type="text"
          id="extra-content-title-input"
          class="form-control"
          v-model="extraContentTitle"
        >
      </div>

       <div class="form-group">
        <label class="typography--body-3 typography--color-secondary typography--font-weight-600 clickable">
          긴지문 이미지
          <img src="/static/images/ic-camera.svg" alt="">
          <input type="file" class="no-display" accept="image/png,image/jpeg,image/jpg" v-on:change="onExtraContentImageChange">
        </label>
        <div class="extra-content-image" v-bind:style="extraContentImgaeBinding"></div>
      </div>
    </div>
    <div slot="modal-footer">
      <button type="button" class="btn btn-secondary mr-10" @click="$emit('cancel')">
        취소
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="save()"
      >
        저장
      </button>
    </div>
  </CustomModal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, get } from 'lodash';

  export default {
    name: 'extra-content-edit-modal',

    props: {
      page: {
        type: Object,
        default() {
          return {};
        },
      },
      card: {
        type: Object,
      },
    },

    data() {
      return {
        acceptableFileTypes: [
          'image/jpg',
          'image/jpeg',
          'image/png',
        ],
        extraContentTitle: null,
        extraContentImageData: null,
        extraContentImageUrl: null,
      };
    },

    computed: {
      ...mapGetters([
      ]),

      hasExtraContent() {
        return !isEmpty(this.page.extra_content);
      },

      extraContentImgaeBinding() {
        if (this.extraContentImageUrl) {
          return {
            'background-image': `url('${this.extraContentImageUrl}')`,
          };
        }

        return {};
      },
    },

    beforeMount() {
      this.extraContentTitle = this.page.extra_content.title;
      this.extraContentImageUrl = this.page.extra_content.image_url;
    },

    methods: {
      ...mapActions([
        'updateExtraContent',
        'removeExtraContent',
        'fetchMyCardPages',
      ]),

      async save() {
        try {
          const params = {
            title: this.extraContentTitle,
          };
          if (this.extraContentImageData) {
            params.imageFile = this.extraContentImageData;
          }
          await this.updateExtraContent({
            pageId: this.page.id,
            params,
          });
        } catch (err) {
          const errorMessage = get(err, 'response.data.error_description', '알 수 없는 오류 입니다.');
          alert(errorMessage);
        }
        const pages = await this.fetchMyCardPages({
          cardId: this.page.card_id,
          isPublisherUser: true,
        });
        this.card.pages = pages;

        this.$emit('ok');
      },

      async remove() {
        await this.removeExtraContent(this.page.extra_content.id);
        const pages = await this.fetchMyCardPages({
          cardId: this.page.card_id,
          isPublisherUser: true,
        });
        this.card.pages = pages;
        this.$emit('ok');
      },

      onExtraContentImageChange(event) {
        const images = event.target.files || event.dataTransfer.files;

        if (!images.length) {
          return null;
        }

        const file = images[0];

        if (!file || file.size === undefined || file.type === undefined) {
          return null;
        }

        if (file.size > this.fileSizeLimit) {
          // alert file size
          return this.$root.$emit('show::modal', 'file-size-alert');
        }

        if (this.acceptableFileTypes.indexOf(file.type) === -1) {
          // alert wrong file type
          return this.$root.$emit('show::modal', 'file-type-alert');
        }

        return this.createMedia(file, 'image');
      },

      createMedia(file) {
        if (!window.FileReader) {
          return this.$root.$emit('show::modal', 'file-reader-unsupported-alert');
        }

        const reader = new window.FileReader();

        reader.onload = (event) => {
          this.extraContentImageData = file;
          this.extraContentImageUrl = event.target.result;
        };
        return reader.readAsDataURL(file);
      },
    },
  };
</script>

<style lang="scss">
  .extra-content-edit-modal {
    .extra-content-edit-modal__form {
      .form-group>.form-control {
        height: 47px;
        font-size: 14px;
      }
    }
    .extra-content-image {
      position: relative;
      height: 120px;
      width: 120px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      margin: 12px 12px 0 12px;
      border-radius: 4px;
      border: 1px solid #F0F0F0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/publishers/components/ExtraContentEditModal.vue